export default __webpack_public_path__ + "static/email-finder-active.png";